import Block from 'components/Block'
import { View } from 'components/View'
import React from 'react'
import { defineMessages } from 'react-intl'
import { useTheme } from 'modules/styles/index.js'
import { SubscriptionPremiumPlan } from 'pages/Premium/FreeVsPremiumFeatures/SubscriptionPlans/Premium/index.js'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy.js'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'

const messages = defineMessages({
  title: {
    id: 'CheckExerciseFormPricing.title',
    defaultMessage: 'What You Get'
  }
})

export function CheckExerciseFormPricing () {
  const theme = useTheme()
  const intl = useIntl()

  return (
    <Block
      style={{
        textAlign: 'center'
      }}
    >
      <View mb={4}>
        <TextTitleCompressedHeavy>
          {formatMessageIntlUtil(intl, messages.title)}
        </TextTitleCompressedHeavy>
      </View>

      <View
        centered
        style={{
          maxWidth: theme.maxWidth.desktopCompact
        }}
      >
        <SubscriptionPremiumPlan
          isStandalone
          shouldBoldMainFeatures
        />
      </View>
    </Block>
  )
}
